// src/components/ProtectedRoute.js
import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext.js";

export default function ProtectedRoute({ children, adminOnly = false, clientManagerAllowed = false }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-4">Carregando...</div>;
  if (!user) return <Navigate to="/login" replace />;

  if (adminOnly) {
    // Se permite client manager, verifica isAdmin OU isClientManager
    if (clientManagerAllowed) {
      if (!user.isAdmin && !user.isClientManager) return <Navigate to="/" replace />;
    } else {
      // Senão, apenas admin
      if (!user.isAdmin) return <Navigate to="/" replace />;
    }
  }

  return children;
}
